<template>
  <div class="activehelp">
    <div class="page1" v-if="index == 0">
      <div class="list" v-for="(q,i) in questions" :key="'q'+i" @click="showQ(i)">{{q.q}}</div>
    </div>
    <div v-else>
      <div class="question">{{questions[index-1].q}}</div>
      <div class="answer" v-html="questions[index-1].a"></div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      questions: [
        {q:"为什么搜不到车辆？",a:"1.请检查车辆是否处于启动状态，并处于P档。<br/>\
          2.请检查手机蓝牙功能是否处于已开启状态。（由于Android10系统BUG，Android10系统版本用户需要开启定位功能）。<br/>\
          3.请检查车辆是否正处于待绑定状态。<br/>\
          为保证您的车辆安全，车辆进入待激活状态后，若5分钟内无任何操作、被推行或驾驶，车辆将自动退出待激活状态，或导致无法搜索到车辆。<br/>\
          您可通过再次启动车辆，在特定时间内通过APP搜索完成激活操作。"},
        {q:"点击连接搜索到的车辆，但是提示连接失败？",a:"1.请检查车辆是否正处于待绑定状态。<br/>\
          为保证您的车辆安全，车辆进入待激活状态后，若5分钟内无任何操作、被推行或驾驶，车辆将自动退出待激活状态，或导致无法搜索到车辆。<br/>\
          您可通过再次启动车辆，在特定时间内通过APP搜索完成激活操作。<br/>\
          2.可能是由于您手机蓝牙的信号不稳定。造成连接困难。您可以尝试重新搜索后再次尝试连接车辆。"},
        {q:"搜索到多辆车，如何确定需要激活目标车辆？",a:"您可以通过对照车架号，来确定您要激活的是哪辆车。车架号在您车辆座桶内充电口如今，如下图：\
          <div style='text-align:center;padding-top:24px;'><img src='/static/img/q3.png' width='180px' alt=''></div>"},
        {q:"一直显示“车辆网络激活中…”，该怎么办？",a:"1.请检查您的车辆网络是否正常。<br/>\
          您可通过车辆屏幕查看网络状态，若发现车辆网络状态不好，建议您将车辆移至开阔的室外环境或网络良好的环境下。<br/>\
          2.请检查您的手机网络是否正常。<br/>\
          可能由于您的手机网络异常或不稳定，导致激活状态未能及时同步。<br/>\
          3.检查您蓝鲨APP的“通知权限”是否开启。您可尝试前往手机设置中心→通知→蓝鲨APP→打开通知权限；（用于手机系统版本差异，操作流程可能存在差异）<br/>\
          4.您可尝试在蓝鲨APP内退出账号并重新登录来解决这个问题。"},
        {q:"激活绑定后，就完成了与车辆的蓝牙连接吗？",a:"激活绑定后，手机与车辆仅完成了BLE（低功耗蓝牙）模块的连接，用于手机与车辆的基本通讯。<br/>\
          如需通过蓝牙连接，使用音乐或电话等蓝牙相关功能，请前往手机系统设置中，通过手机蓝牙搜索进行连接。"},
        {q:"如何解绑车辆？",a:"登录蓝鲨app，从APP侧边栏选择要解绑的车辆，点击删除车辆，勾选删除协议后点击删除即可成功解除绑定。"},
        {q:"APP解绑车辆后，车辆无法进入待激活状态？",a:"APP解绑后，车辆无法重新进入待激活状态，可能是因为当前车辆网络不佳导致的：<br/>\
          1.您可将车辆停放在环境开阔，网络较好的位置，并重启车辆查看状态；<br/>\
          2.检查车辆智能服务是否到期，若智能服务已到期，请续费后，重启车辆进行查看。"}
      ],
      index: 0
    }
  },
  mounted(){
    document.title = "激活帮助"
    this.index = parseInt(this.$route.params.id)
  },
  watch :{
    '$route': function(to,from){
      window.location.reload()
    }
  },
  methods: {
    showQ(i){
      this.$router.push("/bs/activehelp/"+(i+1))
    }
  }
}
</script>

<style lang="less" scoped>
.activehelp{
  height: 100%;
  box-sizing: border-box;
  background: #111117;
  padding: 40px 32px;
  .list{
    color: #F2F2F7;
    font-size: 14px;
    margin-bottom: 32px;
  }
  .question{
    color: #F2F2F7;
    margin-bottom: 24px;
  }
  .answer{
    font-size: 14px;
    line-height: 21px;
    color: #C7CAD1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/activehelp.vue